const sortOrder = (objArray) => objArray.sort((a, b) => ((a.order > b.order) ? 1 : -1));

export default sortOrder;
